<template>
  <main class="flex flex-col py-10 items-center justify-center">
    <empty-wallet />
    <slot></slot>
  </main>
</template>

<script>
export default {
  components: {
    EmptyWallet: () => import('@/assets/v2/icons/EmptyWallet.vue')
  }
}
</script>

<style></style>
